<ng-template [appTopbarTemplate]>
  <div class="title">
    <h4 class="mb-0 pool-title oneline">Talentpool</h4>
  </div>
  <div class="nav">
    <ul class="nav nav-tabs nav-overflow">
      <li class="nav-item"><a class="nav-link" (click)="activateView('activities')" [class.active]="view == 'activities'">Aktivitäten</a></li>
      <li class="nav-item"><a class="nav-link" (click)="activateView('candidates')" [class.active]="view == 'candidates'">Kandidat:innen</a></li>
    </ul>
  </div>
</ng-template>

  <div class="scroll-dummy" *ngIf="!pool"></div>

  <div class="content" [@fadeIn]="state">

    <div class="container">
      <div class="row">

        <div class="col-12">

          <app-pool-activities *ngIf="view == 'activities'" [pool]="pool"></app-pool-activities>
          <app-pool-candidates *ngIf="view == 'candidates'"></app-pool-candidates>
        </div>

      </div>
    </div>
  </div>

  <!--<app-footer-blob></app-footer-blob>-->
